<script setup>
import {useAppStore} from '@/stores/appStore'
import {useModalsStore} from '@/stores/modals'
import Button from '@/common/Button.vue'

const modalsStore = useModalsStore()
const appStore = useAppStore()

const openSupportModal = () => {
    if (appStore.alphaMode) {
        appStore.showSupport = true
    } else {
        modalsStore.show({
            componentName: 'ZendeskModal',
        })
    }
}
</script>

<template>
    <Button class="h-100 rounded-0" title="Show help" @click="openSupportModal">
        <i class="bi-life-preserver"/>
    </Button>
</template>